import {Divider} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledDivider = styled(Divider)(({theme}) => ({
  margin: theme.spacing(1, 1.5),
  height: theme.spacing(4),
}));
